<template>
    <div>
        <p class="text-bold mb-2 mt-4">{{title}}</p>
        <div v-for="(option, index) in options" :key="'total' + index" class="d-inline-block mb-3">
            <img v-bind:src="'/images/master-dashboard/' + type + '_unlocked.svg'" class="icon mr-2" :class="option.completed ? 'completed' : 'notCompleted'" />
            {{option.name}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChaptersProgressList",
        props: {
            title: String,
            options: Array,
            type: String
        },
    }
</script>

<style scoped lang="scss">
    .notCompleted {
        opacity: 0.5
    }

    .icon {
        width: 23px;
        height: 23px;
    }
</style>
